import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  defaultUIConfigurationsGlobalState,
  UIConfigurationsGlobalState,
} from './types';

export const uiConfigurationsSlice = createSlice({
  name: 'uiConfigurations',
  initialState: defaultUIConfigurationsGlobalState,
  reducers: {
    dashboardUIConfigurationIdChanged: (
      state,
      action: PayloadAction<number | null>,
    ): UIConfigurationsGlobalState => {
      return {
        ...state,
        dashboardUIConfigurationId: action.payload,
      };
    },
    patientOverviewUIConfigurationIdChanged: (
      state,
      action: PayloadAction<number | null>,
    ): UIConfigurationsGlobalState => {
      return {
        ...state,
        patientOverviewUIConfigurationId: action.payload,
      };
    },
    patientListConfigurationIdChanged: (
      state,
      action: PayloadAction<number | null>,
    ): UIConfigurationsGlobalState => {
      return {
        ...state,
        patientListConfigurationId: action.payload,
      };
    },
    calendarConfigurationIdChanged: (
      state,
      action: PayloadAction<number | null>,
    ): UIConfigurationsGlobalState => {
      return {
        ...state,
        calendarConfigurationId: action.payload,
      };
    },
  },
});

export const UIConfigurationsActions = uiConfigurationsSlice.actions;
